"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCookie = function getCookie(name) {
  var re = new RegExp(name + "=([^;]+)");
  var value = re.exec(document.cookie); // eslint-disable-line
  return value != null ? unescape(value[1]) : null;
};
exports.default = getCookie;